import React from 'react';
import './index.scss';

const formatPrice = (props: { className?: string | undefined; price: any }) => {
  const price = props.price.toFixed(2).toString();
  console.log('props', price);

  const [integer, point] = price.split('.');
  return (
    <span className={props.className}>
      <span className="sign">¥</span><span className="integer">{integer}</span>
      <span className="point">.{point}</span>
    </span>
  );
};
export default formatPrice;
